export const CategoryOption = [
  { value: "Cardio", label: "Cardio" },
  { value: "Biceps", label: "Biceps" },
  { value: "Abs", label: "Abs" },
  { value: "Adductors", label: "Adductors" },
  { value: "Shoulder", label: "Shoulder" },
  { value: "Chest", label: "Chest" },
  { value: "Forearm", label: "Forearm" },
  { value: "Obliques", label: "Obliques" },
  { value: "Quads", label: "Quads" },
  { value: "Lower_Back", label: "Lower Back" },
  { value: "Glutes", label: "Glutes" },
  { value: "Traps", label: "Traps" },
  { value: "Triceps", label: "Triceps" },
  { value: "Abductors", label: "Abductors" },
  { value: "Hamstrings", label: "Hamstrings" },
  { value: "Calves", label: "Calves" },
  { value: "Full_Body", label: "Full Body" },
  { value: "Upper_Body", label: "Upper Body" },
  { value: "Lower_Body", label: "Lower Body" },
];

export const ChallengesCategoryOption = [
  { value: "Eating_Healthy", label: "Eating Healthy" },
  { value: "Physical_Activity", label: "Physical Activity" },
  { value: "Stress_Management", label: "Stress Management" },
  { value: "Sleep_Hygiene", label: "Sleep Hygiene" },
  { value: "Weight_Lifting", label: "Weight Lifting" },
  { value: "Jogging", label: "Jogging" },
];
